import {NgModule} from '@angular/core';
import {QuizzesServiceProvider} from './services/quizzes-service/quizzes-service';
import {SellionsQuizComponent} from "./components/sellions-quiz/sellions-quiz";
import {CommonModule} from "@angular/common";

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    QuizzesServiceProvider
  ],
  declarations: [
    SellionsQuizComponent
  ],
  exports: [
    SellionsQuizComponent
  ]
})
export class SellionsQuizzesModule {}



// WEBPACK FOOTER //
// ./src/modules/quizzes/quizzes.module.ts